/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { AmexIcon, PaymentCardIcon, VisaIcon, EloIcon, UnionPayIcon, DinersIcon, DiscoverIcon, JcbIcon, MasterCardIcon, CartesBancairesIcon } from 'components/elements';
import Styles from './styles';

const useStyles = makeStyles(Styles);

const brands = {
  visa: VisaIcon,
  mastercard: MasterCardIcon,
  amex: AmexIcon,
  cartes_bancaires: CartesBancairesIcon,
  elo: EloIcon,
  diners_club: DinersIcon,
  discover: DiscoverIcon,
  jcb: JcbIcon,
  unionpay: UnionPayIcon,
};

function CardDetails({ brand, expMonth, expYear, last4, isDefault, name: cardHolder }) {
  const classes = useStyles(Styles);
  const { t } = useTranslation('labels');
  const BrandImage = useMemo(() => brands[brand] || PaymentCardIcon, [brand]);

  return (
    <div className={classes.cardDetailsWrapper}>
      <div className={classes.brandIconWrapper}>
        <BrandImage />
      </div>
      <Typography data-testid="cardInfoText" sx={{ fontWeight: 'bold', textTransform: 'capitalize' }} color="text.secondary" variant="body2" component="span">
        {`${brand} ****${last4} (${expMonth}/${String(expYear).slice(-2)}) ${cardHolder}`}
      </Typography>
      <p className={classes.defaultCard}>{isDefault ? `( ${t('stripe_default')} )` : null}</p>
    </div>
  );
}

CardDetails.propTypes = {
  brand: PropTypes.string,
  expMonth: PropTypes.number,
  expYear: PropTypes.number,
  last4: PropTypes.string,
  name: PropTypes.string,
  isDefault: PropTypes.bool,
};

CardDetails.defaultProps = {
  name: '',
  expMonth: '',
  expYear: '',
  last4: '',
  brand: '',
  isDefault: false,
};

export default CardDetails;
